import _extends from "@babel/runtime/helpers/esm/extends";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _class, _class2, _temp;

import React from 'react';
import { getRandomID, isNonNullable } from "../../../lib/utils";
import { DropdownContainer } from "../../DropdownContainer";
import { Input } from "../../../components/Input";
import { InputLikeText } from "../../InputLikeText";
import { RenderLayer } from "../../RenderLayer";
import { Spinner } from "../../../components/Spinner";
import { ArrowChevronDownIcon } from "../../icons/16px";
import { CommonWrapper } from "../../CommonWrapper";
import { MobilePopup } from "../../MobilePopup";
import { responsiveLayout } from "../../../components/ResponsiveLayout/decorator";
import { rootNode, getRootNode } from "../../../lib/rootNode";
import { createPropsGetter } from "../../../lib/createPropsGetter";
import { isTheme2022 } from "../../../lib/theming/ThemeHelpers";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { LoadingIcon } from "../../icons2022/LoadingIcon";
import { ArrowDownIcon } from "../ArrowDownIcon";
import { ComboBoxMenu } from "../ComboBoxMenu";
import { ComboBoxRequestStatus } from "../CustomComboBoxTypes";
import { styles } from "../CustomComboBox.styles";
import { CustomComboBoxDataTids } from "../CustomComboBox";
import { getComboBoxTheme } from "../getComboBoxTheme";
export var ComboBoxViewIds = {
  menu: 'ComboBoxView__menu'
};
export var ComboBoxView = responsiveLayout(_class = rootNode(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ComboBoxView, _React$Component);

  function ComboBoxView() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.getProps = createPropsGetter(ComboBoxView.defaultProps);
    _this.mobileInput = null;
    _this.dropdownContainerRef = /*#__PURE__*/React.createRef();
    _this.menuId = ComboBoxViewIds.menu + getRandomID();

    _this.getComboBoxMenu = function () {
      var _this$props = _this.props,
          items = _this$props.items,
          loading = _this$props.loading,
          opened = _this$props.opened,
          refMenu = _this$props.refMenu,
          maxMenuHeight = _this$props.maxMenuHeight,
          renderTotalCount = _this$props.renderTotalCount,
          renderNotFound = _this$props.renderNotFound,
          totalCount = _this$props.totalCount,
          size = _this$props.size;

      var _this$getProps = _this.getProps(),
          repeatRequest = _this$getProps.repeatRequest,
          requestStatus = _this$getProps.requestStatus,
          renderItem = _this$getProps.renderItem,
          itemWrapper = _this$getProps.itemWrapper;

      return /*#__PURE__*/React.createElement(ComboBoxMenu, {
        menuId: _this.menuId,
        items: items,
        loading: loading,
        maxMenuHeight: maxMenuHeight,
        onValueChange: _this.handleItemSelect,
        opened: opened,
        refMenu: refMenu,
        renderTotalCount: renderTotalCount,
        renderItem: renderItem,
        renderNotFound: renderNotFound,
        itemWrapper: itemWrapper,
        renderAddButton: _this.renderAddButton,
        repeatRequest: repeatRequest,
        requestStatus: requestStatus,
        totalCount: totalCount,
        isMobile: _this.isMobileLayout,
        size: size
      });
    };

    _this.renderMenu = function () {
      var _this$props2 = _this.props,
          menuAlign = _this$props2.menuAlign,
          opened = _this$props2.opened,
          menuPos = _this$props2.menuPos;
      return opened && /*#__PURE__*/React.createElement(DropdownContainer, {
        menuPos: menuPos,
        align: menuAlign,
        getParent: _this.getParent,
        disablePortal: _this.props.disablePortal,
        ref: _this.dropdownContainerRef
      }, _this.getComboBoxMenu());
    };

    _this.renderMobileMenu = function () {
      var rightIcon = null;
      var _this$props3 = _this.props,
          loading = _this$props3.loading,
          items = _this$props3.items,
          opened = _this$props3.opened,
          onFocus = _this$props3.onFocus,
          onInputValueChange = _this$props3.onInputValueChange,
          placeholder = _this$props3.placeholder,
          textValue = _this$props3.textValue;

      if (loading && items && !!items.length) {
        rightIcon = _this.renderSpinner();
      }

      var inputProps = {
        autoComplete: 'off',
        autoFocus: true,
        width: '100%',
        onFocus: onFocus,
        onValueChange: onInputValueChange,
        value: textValue,
        placeholder: placeholder,
        rightIcon: rightIcon
      };
      return opened && /*#__PURE__*/React.createElement(MobilePopup, {
        headerChildComponent: /*#__PURE__*/React.createElement(Input, _extends({
          ref: _this.refMobileInput
        }, inputProps)),
        onCloseRequest: _this.props.onMobileClose,
        opened: true
      }, _this.getComboBoxMenu());
    };

    _this.getParent = function () {
      return getRootNode(_assertThisInitialized(_this));
    };

    _this.renderAddButton = function () {
      return _this.getProps().renderAddButton(_this.props.textValue);
    };

    _this.handleMobileFocus = function () {
      var _this$mobileInput;

      _this.props.onInputClick == null ? void 0 : _this.props.onInputClick();
      (_this$mobileInput = _this.mobileInput) == null ? void 0 : _this$mobileInput.focus();
    };

    _this.handleItemSelect = function (item) {
      if (_this.props.onValueChange) {
        _this.props.onValueChange(item);
      }

      if (_this.isMobileLayout) {
        _this.props.onMobileClose == null ? void 0 : _this.props.onMobileClose();
      }
    };

    _this.refInput = function (input) {
      if (_this.props.refInput) {
        _this.props.refInput(input);
      }

      _this.input = input;
    };

    _this.renderSpinner = function () {
      return /*#__PURE__*/React.createElement("span", {
        className: styles.spinnerWrapper()
      }, /*#__PURE__*/React.createElement(Spinner, {
        type: "mini",
        caption: "",
        dimmed: true
      }));
    };

    _this.getRightIcon = function () {
      var _this$props4 = _this.props,
          loading = _this$props4.loading,
          items = _this$props4.items,
          drawArrow = _this$props4.drawArrow,
          rightIcon = _this$props4.rightIcon,
          size = _this$props4.size;

      if (loading && items && !!items.length) {
        if (isTheme2022(_this.theme)) {
          return /*#__PURE__*/React.createElement(LoadingIcon, {
            size: size
          });
        }

        return _this.renderSpinner();
      }

      if (rightIcon || drawArrow) {
        if (isTheme2022(_this.theme)) {
          return rightIcon || /*#__PURE__*/React.createElement(ArrowDownIcon, {
            size: size
          });
        }

        return /*#__PURE__*/React.createElement("span", {
          className: styles.rightIconWrapper()
        }, rightIcon != null ? rightIcon : /*#__PURE__*/React.createElement(ArrowChevronDownIcon, null));
      }

      return null;
    };

    _this.refMobileInput = function (input) {
      _this.mobileInput = input;
    };

    return _this;
  }

  var _proto = ComboBoxView.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$dropdownContain;

    if (this.props.autoFocus && this.props.onFocus) {
      this.props.onFocus();
    }

    this.props.opened && ((_this$dropdownContain = this.dropdownContainerRef.current) == null ? void 0 : _this$dropdownContain.position());
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var input = this.input,
        props = this.props;

    if (props.editing && !prevProps.editing && input) {
      input.focus();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = getComboBoxTheme(theme);
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: _this2.theme
      }, _this2.renderMain());
    });
  };

  _proto.renderMain = function renderMain() {
    var _this$props5 = this.props,
        onMouseEnter = _this$props5.onMouseEnter,
        onMouseLeave = _this$props5.onMouseLeave,
        onMouseOver = _this$props5.onMouseOver,
        opened = _this$props5.opened;

    var _this$getProps2 = this.getProps(),
        onClickOutside = _this$getProps2.onClickOutside,
        onFocusOutside = _this$getProps2.onFocusOutside,
        width = _this$getProps2.width;

    var isMobile = this.isMobileLayout;
    var input = this.renderInput();
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement(RenderLayer, {
      onClickOutside: onClickOutside,
      onFocusOutside: onFocusOutside,
      active: opened
    }, /*#__PURE__*/React.createElement("span", {
      "data-tid": CustomComboBoxDataTids.comboBoxView,
      style: {
        width: width
      },
      className: styles.root(),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseOver: onMouseOver,
      ref: this.setRootNode
    }, input, isMobile ? this.renderMobileMenu() : this.renderMenu())));
  };

  _proto.renderInput = function renderInput() {
    var isMobile = this.isMobileLayout;
    var _this$props6 = this.props,
        align = _this$props6.align,
        borderless = _this$props6.borderless,
        disabled = _this$props6.disabled,
        editing = _this$props6.editing,
        error = _this$props6.error,
        onFocus = _this$props6.onFocus,
        onInputBlur = _this$props6.onInputBlur,
        onInputValueChange = _this$props6.onInputValueChange,
        onInputFocus = _this$props6.onInputFocus,
        onInputClick = _this$props6.onInputClick,
        onInputKeyDown = _this$props6.onInputKeyDown,
        placeholder = _this$props6.placeholder,
        textValue = _this$props6.textValue,
        value = _this$props6.value,
        warning = _this$props6.warning,
        refInputLikeText = _this$props6.refInputLikeText,
        leftIcon = _this$props6.leftIcon,
        inputMode = _this$props6.inputMode,
        size = _this$props6.size,
        ariaDescribedby = _this$props6['aria-describedby'],
        ariaLabel = _this$props6['aria-label'];

    var _this$getProps3 = this.getProps(),
        renderValue = _this$getProps3.renderValue;

    var rightIcon = this.getRightIcon();

    if (editing) {
      return /*#__PURE__*/React.createElement(Input, {
        align: align,
        borderless: borderless,
        disabled: disabled,
        error: error,
        maxLength: this.props.maxLength,
        onBlur: isMobile ? undefined : onInputBlur,
        onValueChange: onInputValueChange,
        onFocus: onInputFocus,
        onClick: isMobile ? this.handleMobileFocus : onInputClick,
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        value: textValue || '',
        onKeyDown: onInputKeyDown,
        placeholder: placeholder,
        width: "100%",
        size: size,
        ref: this.refInput,
        warning: warning,
        inputMode: inputMode,
        autoComplete: "off",
        "aria-describedby": ariaDescribedby,
        "aria-controls": this.menuId,
        "aria-label": ariaLabel
      });
    }

    return /*#__PURE__*/React.createElement(InputLikeText, {
      align: align,
      borderless: borderless,
      error: error,
      onFocus: onFocus,
      leftIcon: leftIcon,
      rightIcon: rightIcon,
      disabled: disabled,
      warning: warning,
      placeholder: placeholder,
      size: size,
      width: "100%",
      ref: refInputLikeText,
      "aria-describedby": ariaDescribedby,
      "aria-controls": this.menuId
    }, isNonNullable(value) && renderValue ? renderValue(value) : null);
  };

  return ComboBoxView;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'ComboBoxView', _class2.displayName = 'ComboBoxView', _class2.defaultProps = {
  renderItem: function renderItem(item) {
    return item;
  },
  renderValue: function renderValue(item) {
    return item;
  },
  renderAddButton: function renderAddButton() {
    return null;
  },
  repeatRequest: function repeatRequest() {
    return undefined;
  },
  requestStatus: ComboBoxRequestStatus.Unknown,
  onClickOutside: function onClickOutside() {
    /**/
  },
  onFocusOutside: function onFocusOutside() {
    /**/
  },
  size: 'small',
  width: 250
}, _temp)) || _class) || _class;